import styled from "styled-components";
import { MatchupGameCardProps } from "./MatchupGameCard.types";
import { typographyMixin } from "../../../typography";

type Props = Pick<MatchupGameCardProps, "theme">;

export const StyledMatchupGameCard = styled.div.attrs({
  className: "matchupgamecard",
})`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 1fr;
  height: 1fr;
  border-radius: 5px;
  background: #fff;
  box-shadow: 4px 4px 10px 0px rgba(0, 0, 0, 0.25);
  ${typographyMixin}
`;

export const Header = styled.div.attrs({
  className: "matchupgamecard-header",
})<Props>`
  height: 38px;
  width: 100%;
  background-color: ${(props) => props.theme.primaryColor};
  color: ${(props) => props.theme.textOnPrimaryColor};
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  display: flex;
  justify-content: flex-start;
  padding: 0.5rem 0rem 0.5rem 1.5rem;
  align-items: center;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
  flex: 1;
`;

export const Location = styled.div.attrs({
  className: "matchupgamecard-location",
})`
  padding-top: 1rem;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
  flex: 1;
`;

export const ContentContainer = styled.div.attrs({
  className: "matchupgamecard-contentcontainer",
})`
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex: 6;
  padding-bottom: 1rem;
`;

export const DateContainer = styled.div.attrs({
  className: "matchupgamecard-datecontainer",
})`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
`;
export const Date = styled.div.attrs({
  className: "matchupgamecard-date",
})`
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
  opacity: 0.6;
`;
export const Time = styled.div.attrs({
  className: "matchupgamecard-time",
})`
  text-align: center;
  font-size: 2rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  padding-bottom: 0.5rem;
  white-space: nowrap;
`;

export const Team = styled.div.attrs({
  className: "matchupgamecard-team",
})`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 150px;
  padding: 0rem 0.5rem 1rem 0.5rem;
  flex: 2;
`;

export const TeamImg = styled.img.attrs({
  className: "matchupgamecard-teamimg",
})`
  width: 100%;
  height: 100%;
  max-width: 128px;
  max-height: 128px;
  object-fit: contain;
`;

export const TeamTitle = styled.div.attrs({
  className: "matchupgamecard-teamtitle",
})`
  text-align: center;
  font-size: 0.85rem;
  font-weight: 600;
`;
